/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Cta_TitleInputs */

const en_mk_sec_pg_cta_title = /** @type {(inputs: Mk_Sec_Pg_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A question this page did not answer?`)
};

const id_mk_sec_pg_cta_title = /** @type {(inputs: Mk_Sec_Pg_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada pertanyaan yang tidak terjawab di sini?`)
};

/**
* | output |
* | --- |
* | "A question this page did not answer?" |
*
* @param {Mk_Sec_Pg_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_cta_title = /** @type {((inputs?: Mk_Sec_Pg_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_cta_title(inputs)
	return en_mk_sec_pg_cta_title(inputs)
});